import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import Shops from './components/shops/Shops';

document.addEventListener('DOMContentLoaded', () => {
  const shopsElement = document.getElementById('react-shops');
  const shops = JSON.parse(shopsElement.dataset.shops);

  window.broadCastDirectionsClick = function onDirectionClick(shop) {
    const event = new CustomEvent('build_direction', { detail: shop });
    window.dispatchEvent(event);
  };

  window.infoWindowOpened = function onInfoWindowOpened(shopId) {
    const event = new CustomEvent('info_window_opened', { detail: shopId });
    window.dispatchEvent(event);
  };

  window.infoWindowClosed = function onInfoWindowClosed(shopId) {
    const event = new CustomEvent('info_window_closed', { detail: shopId });
    window.dispatchEvent(event);
  };

  createRoot(
    shopsElement,
  ).render(
    <Provider store={window.store}>
      <Shops defaultData={shops} />
    </Provider>,
  );
});
